import React from 'react';
import { Paintbrush, Droplets } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ServiceSection() {
  return <section id="services" className="py-16 bg-gray-50" data-id="element-357">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-358">
        <div className="text-center" data-id="element-359">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-360">
            Our Services
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-361">
            Standardized service offerings with quality assurance and warranty
            coverage
          </p>
        </div>
        <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 mx-auto max-w-4xl" data-id="element-362">
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-363">
            <div className="bg-primary/10 p-6" data-id="element-364">
              <Paintbrush className="h-12 w-12 text-primary mx-auto" data-id="element-365" />
            </div>
            <div className="p-6" data-id="element-366">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-367">
                Painting Services
              </h3>
              <p className="mt-2 text-gray-600" data-id="element-368">Smart Paints 健康家居</p>
              <ul className="mt-4 space-y-2" data-id="element-369">
                <li className="flex items-start" data-id="element-370">
                  <span className="flex-shrink-0 h-5 w-5 rounded-full bg-primary/10 flex items-center justify-center mr-2" data-id="element-371">
                    <span className="h-2 w-2 rounded-full bg-primary" data-id="element-372"></span>
                  </span>
                  <span data-id="element-373">Green Home 0 VOC 健康漆 packages</span>
                </li>
                <li className="flex items-start" data-id="element-374">
                  <span className="flex-shrink-0 h-5 w-5 rounded-full bg-primary/10 flex items-center justify-center mr-2" data-id="element-375">
                    <span className="h-2 w-2 rounded-full bg-primary" data-id="element-376"></span>
                  </span>
                  <span data-id="element-377">Standardized pricing by area/room</span>
                </li>
                <li className="flex items-start" data-id="element-378">
                  <span className="flex-shrink-0 h-5 w-5 rounded-full bg-primary/10 flex items-center justify-center mr-2" data-id="element-379">
                    <span className="h-2 w-2 rounded-full bg-primary" data-id="element-380"></span>
                  </span>
                  <span data-id="element-381">Color consultation services</span>
                </li>
                <li className="flex items-start" data-id="element-382">
                  <span className="flex-shrink-0 h-5 w-5 rounded-full bg-primary/10 flex items-center justify-center mr-2" data-id="element-383">
                    <span className="h-2 w-2 rounded-full bg-primary" data-id="element-384"></span>
                  </span>
                  <span data-id="element-385">2-3 year warranty coverage</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-386">
            <div className="bg-primary/10 p-6" data-id="element-387">
              <Droplets className="h-12 w-12 text-primary mx-auto" data-id="element-388" />
            </div>
            <div className="p-6" data-id="element-389">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-390">
                Waterproofing Services
              </h3>
              <p className="mt-2 text-gray-600" data-id="element-391">
                Complete moisture protection solutions
              </p>
              <ul className="mt-4 space-y-2" data-id="element-392">
                <li className="flex items-start" data-id="element-393">
                  <span className="flex-shrink-0 h-5 w-5 rounded-full bg-primary/10 flex items-center justify-center mr-2" data-id="element-394">
                    <span className="h-2 w-2 rounded-full bg-primary" data-id="element-395"></span>
                  </span>
                  <span data-id="element-396">Bathroom, roof, wall, and balcony solutions</span>
                </li>
                <li className="flex items-start" data-id="element-397">
                  <span className="flex-shrink-0 h-5 w-5 rounded-full bg-primary/10 flex items-center justify-center mr-2" data-id="element-398">
                    <span className="h-2 w-2 rounded-full bg-primary" data-id="element-399"></span>
                  </span>
                  <span data-id="element-400">Standardized application procedures</span>
                </li>
                <li className="flex items-start" data-id="element-401">
                  <span className="flex-shrink-0 h-5 w-5 rounded-full bg-primary/10 flex items-center justify-center mr-2" data-id="element-402">
                    <span className="h-2 w-2 rounded-full bg-primary" data-id="element-403"></span>
                  </span>
                  <span data-id="element-404">6 months to 1 year warranty</span>
                </li>
                <li className="flex items-start" data-id="element-405">
                  <span className="flex-shrink-0 h-5 w-5 rounded-full bg-primary/10 flex items-center justify-center mr-2" data-id="element-406">
                    <span className="h-2 w-2 rounded-full bg-primary" data-id="element-407"></span>
                  </span>
                  <span data-id="element-408">24-hour water testing validation</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-10 text-center" data-id="element-409">
          <Link to="/request-service" className="inline-block px-6 py-3 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors" data-id="element-410">
            Request Service Now
          </Link>
        </div>
      </div>
    </section>;
}